var update_preview = function(){

  setTimeout( function(){
    update_confirm();
//     var exist_file_field = check_file_field();
//     if(exist_file_field){
//       pbjQuery("#add_build_another").hide();
//     }else{
//       pbjQuery("#add_build_another").show();
//     }

  	var _html = $("#order_steps").html()
    $('#order-preview').html(_html)
    change_design();
    if(($("#option_193049_6").hasClass('selected') && $('#option_193048_1').hasClass('selected')) || ($("#option_193048_2").hasClass('selected') && $("#option_193049_1").hasClass('selected'))){
      $('#slot-width-option-1').prop('disabled', true);
      $("#slot-width-option-1").hide();
    }
    else{
      $('#slot-width-option-1').prop('disabled', false);
      $("#slot-width-option-1").show();
    }

  },300 )

}

function select_boxes(id,x,y){

  var index = parseInt($("#"+id).find("option:selected").val())+1;
  	for(var i=x; i<=y; i++){
      if($("#option_193130_"+i).hasClass('selected'))
        $("#option_193130_"+i).click();
    }
    $("#option_193130_"+index).click();

}

var font_style = '';
var letter_case = '';
var signage_text = '';
var additonal = '';

var change_design = function (){

  if($("#custom_option_193051_1").find("option:selected").text() != 'Please select'){
    font_style = "Font style: "+ $("#custom_option_193051_1").find("option:selected").text();
  }
  else{
    font_style = '';
  }
  if($("#custom_option_193051_2").find("option:selected").text() != 'Please select'){
    letter_case = "Letter case: "+ $("#custom_option_193051_2").find("option:selected").text();
  }
  else{
    letter_case = '';
  }
  if($("#custom_option_193051_3").find(".full_width").val() != ''){
    signage_text = "Signage text: "+ $("#custom_option_193051_3").find(".full_width").val();
   }
  else{
    signage_text = '';
  }
   if($("#custom_option_193051_4").find(".full_width").val() != ''){
    additonal = "Additional comments: "+ $("#custom_option_193051_4").find(".full_width").val();
   }
  else{
  	additonal = '';
  }

  if($('#step-design').length == 0){
     if($("#custom_option_193051_4").find(".full_width").val() != '' || $("#custom_option_193051_3").find(".full_width").val() != '' || $("#custom_option_193051_2").find("option:selected").text() != 'Please select' || $("#custom_option_193051_1").find("option:selected").text() != 'Please select')
     {
  	  var cart = "<div class='confirm_step' id='step-design'><div class='confirm_step_title'>Design </div><div class='confirm_step_select'>"+font_style+" "+letter_case+' '+signage_text+' '+additonal+"</div><div class='confirm_step_price'>$0.00</div></div>";
  	  $(".order_steps").append(cart);
     }
  }
  else{
   if($("#custom_option_193051_4").find(".full_width").val() != '' || $("#custom_option_193051_3").find(".full_width").val() != '' || $("#custom_option_193051_2").find("option:selected").text() != 'Please select' || $("#custom_option_193051_1").find("option:selected").text() != 'Please select')
    {
      var cart = "<div class='confirm_step_title'>Design </div><div class='confirm_step_select'>"+font_style+" "+letter_case+' '+signage_text+' '+additonal+"</div><div class='confirm_step_price'>$0.00</div>";
    	$(".order_steps #step-design").html(cart);
    }
    else{
    	$(".order_steps #step-design").html("");
    }
  }
  var _html = $(".order_steps").html()
    $('#order-preview').html(_html)

}

$(document).ready(function() {
  $("#step_title_3").hide();
  $("#step_options_3").hide();
  $("#step_category_2").hide();

  var choices = $("#step_options_3 .choices");
  var slot_width_label = $(choices[0]).find('.option_name').text().split(":");
  var slot_position_label = $(choices[2]).find('.option_name').text().split(":");
  var signage_method_label = $(choices[5]).find('.option_name').text().split("-");
  var installation_label = $(choices[8]).find('.option_name').text().split(" ");

  $('.option_image_pane').prepend('<div id="order-preview" class="verify_pane"></div>');
	var selectboxes = '<div class="step_title">Options</div><div id="option_slot_width" class="slot_width option_choices"><div class="custom-field"><div class="option_id"><span class="field-required">*</span><div class="option_label">'+slot_width_label[0]+'</div><span id="semicolon1">:</span> </div><div class="option_value"><select id="select_1" class="full_width custom_field"><option id="slot-width-option"></option></select></div></div><div class="custom-field" id="landscape-option"><div class="option_id"> <span class="field-required">*</span><div class="option_label">'+slot_position_label[0]+'</div><span id="semicolon1">:</span></div><div class="option_value"><select id="select_4" class="full_width custom_field"><option id="slot_position"></option></select></div></div><div class="custom-field"><div class="option_id"> <span class="field-required">*</span><div class="option_label">Signage Method</div><span id="semicolon1">:</span></div><div class="option_value"><select id="select_3" class="full_width custom_field"><option id="laser"></option></select></div></div><div class="custom-field"><div class="option_id"><span class="field-required">*</span><div class="option_label">Installation</div><span id="semicolon1">:</span> </div> <div class="option_value"><select id="select_2" class="full_width custom_field"><option id="delivered"></option></select></div></div></div>';

  	$('#step_3').prepend(selectboxes);

	$("#landscape-option").hide();
	$(" #select_4").hide();

  $('#option_193048_2').click(function(){
     $("#landscape-option").show();
    $(" #select_4").show();
  });
  $('#option_193048_1').click(function(){
     $("#landscape-option").hide();
    $(" #select_4").hide();
  });

  $('#option_193049_1').click(function(){
   $(" #select_4").hide();
   $("#landscape-option").hide();
  });
  $('#option_193049_2').click(function(){
    $(" #select_4").hide();
    $("#landscape-option").hide();
   });

   $('#option_193049_3').click(function(){
    $(" #select_4").show();
    $("#landscape-option").show();
   });

   $('#option_193049_4').click(function(){
    $(" #select_4").show();
    $("#landscape-option").show();
   });

   $('#option_193049_5').click(function(){
    $(" #select_4").show();
    $("#landscape-option").show();
   });

  if($('#option_193048_2').hasClass('selected')){
  }

  for(var i=0; i<=1; i++){
    var option1 = "<option value="+i+" id='slot-width-option-"+i+"'>"+$(choices[i]).find('.option_name').html()+'</option>';
    $('#select_1').append(option1);

  }
   for(var i=2; i<=3; i++){
    var option1 = "<option value="+i+" id='slot-width-option-"+i+"'>"+$(choices[i]).find('.option_name').html()+'</option>';
    $('#select_4').append(option1);

  }
  for(var i=4; i<=7; i++){
    var option2 = "<option value="+i+" id='delivered-"+i+"'>"+$(choices[i]).find('.option_name').html()+'</option>';
    $('#select_2').append(option2);

  }
   for(var i=8; i<=9; i++){
    var option3 = "<option value="+i+" id='laser-"+i+"'>"+$(choices[i]).find('.option_name').html()+'</option>';
    $('#select_3').append(option3);

  }

  $('.choices').click(update_preview);
  $('#navigation_buttons .next-btn').click(function(){
  	if($("#step_header_4").hasClass('current')){
      if($("#custom_option_193051_1").find("option:selected").text() == 'Please select' || $("#custom_option_193051_2").find("option:selected").text() == 'Please select' || $("#custom_option_193051_3").find(".full_width").val() == '' || $("#custom_option_193051_4").find(".full_width").val() == ''){
        $('#builder_verify_button').hide();
      }
      else{
        $('#builder_verify_button').show();
      }
    }
  });
//   $('#navigation_buttons .back-btn').click( function(){
//   	$('.next-btn').prop('disabled', false);
//   });
  $("#option_193048_1, #option_193048_2").click(function (){
    $('#select_1').prop('selectedIndex',0);
    $('#select_2').prop('selectedIndex',0);
    $('#select_3').prop('selectedIndex',0);
    $('#select_4').prop('selectedIndex',0);

    $("#custom_option_193051_1 .full_width").prop('selectedIndex',0);
    $("#custom_option_193051_2 .full_width").prop('selectedIndex',0);
    $("#custom_option_193051_3 .full_width").val('');
    $("#custom_option_193051_4 .full_width").val('');

  });

  $("#select_1").change(function () {
    select_boxes('select_1',1,2);
  });

  $("#select_2").change(function () {
    select_boxes('select_2',5,8);
  });

  $("#select_3").change( function (){
    select_boxes('select_3',9,10);
  });

  $("#select_4").change( function (){
    select_boxes('select_4',3,4);
  });
  $('#customize select option:first-child').text('Please select');
  var font_style = '';
  $("#custom_option_193051_1, #custom_option_193051_2, #custom_option_193051_3").change( function(){
  	change_design();
     if($("#step_header_4").hasClass('current')){
      if($("#custom_option_193051_1").find("option:selected").text() == 'Please select' || $("#custom_option_193051_2").find("option:selected").text() == 'Please select' || $("#custom_option_193051_3").find(".full_width").val() == ''){
        $('#builder_verify_button').hide();
      }
      else{
        $('#builder_verify_button').show();
      }
    }

  });

  $("#select_1, #select_2, #select_3, #select_4").change(function(){
     $('#builder_verify_button').hide();

  });

  $("#builder_verify_button .btn").attr('onclick','').unbind('click');
  $("#builder_verify_button .btn").click(function(e){

    e.preventDefault();
    //change_design();

    setTimeout( function(){
    	change_design();
      	//taken from popup_confirm();
      	var exist_file_field = check_file_field();
        if(exist_file_field){
          pbjQuery("#add_build_another").hide();
        }else{
          pbjQuery("#add_build_another").show();
        }
        pbjQuery.facebox({ div: '#confirmation_pane_facebox'});

    }, 300 )
  });



});

$( document ).ready(function() {
  $( ".field-required" ).remove();
  $( ".required .option_label" ).prepend( '<span class="required">*</span>' );
});
